export default __webpack_public_path__ + "static/falback-post-image-0e4ba7712a8d341a208f54c8b3f6d4de.jpg";